var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-item",class:{active: _vm.selected}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title.slice(0,2)))]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title.slice(-2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }